<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Hooks
	import { onMount } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';
	import { postReq } from 'src/services/http';
	//Stores
		//Helpers
	import { real_id, real_id_z } from 'src/helpers/interface_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Design system components
	import { Button, Radio, Text } from '@Shelly/shelly-design-system';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);

	const inputOptions = ['momentary', 'toggle', 'detached'];
	const _input_options_i18n =
		device.category === 'roller'
			? [
					$format('option_momentary_roller', {
						default:
							'Momentary - Set Shelly device to be "Momentary" switch. Push-for "ON" or Push-for "OFF".',
					}),
					$format('option_toggle_switch_roller', {
						default:
							'Toggle Switch - Set Shelly device to be "Toggle" switch. Act as a flip switch with one state for "ON" and one state for "OFF".',
					}),
					$format('btn_mode_detached_description', {
						default:
							'Detached Switch - Set Shelly device to be in "Detached" switch mode - switch is separated from the relays.',
					}),
				]
			: [
					$format('option_momentary_by_category', {
						values: {
							device_category: $format(`this_${device.category}`, {
								default:
									'Momentary - Set this {device.category} to be "Momentary" switch. Push-for "ON" or Push-for "OFF".',
							}),
						},
					}),
					$format('option_toggle_switch_by_category', {
						values: {
							device_category: $format(`this_${device.category}`),
							default:
								'Toggle Switch - Set this {device.category} to be "Toggle" switch. Act as a flip switch with one state for "ON" and one state for "OFF".',
						},
					}),
					$format('option_edge_switch_by_category', {
						values: {
							device_category: $format(`this_${device.category}`),
							default:
								'Edge Switch - Set this {device.category} to be "Edge" switch. Changes state on every hit.',
						},
					}),
				];

	let settings = $settingsStore,
		inputTypes = {},
		deviceChannel = device.channel,
		setting = deviceChannel === 0 ? 1 : 2,
		loading = false,
		cache;

	onMount(() => {
		inputTypes[deviceChannel] = settings[`Configuration:0`][setting];
		cache = Object.assign({}, { ...inputTypes });
	});

	const setInputType = (value) => {
		inputTypes[deviceChannel] = value;
	};
	const sentRequest = async () => {
		if (JSON.stringify(cache) !== JSON.stringify(inputTypes)) {
			loading = true;

			const params = {
				id: real_id_z(device.id), //gateway's id
				a: 'call', //inclusion command
				cc: 'Configuration', //command class
				m: 'set', //method
				ep: 0, //endpoint
				params: JSON.stringify([{ parameter: setting, value: +inputTypes[deviceChannel] }]), //parameters parameter - setting index, value - setting value
			};
			const res: SettingRequest = await postReq(`/fast/device/zw`, {
				...params,
			});

			if (res.isok) {
				params.m = 'get'; //override method
				params.params = JSON.stringify([+setting]); //override params
				const res_get: SettingRequest = await postReq(`/fast/device/zw`, {
					...params,
				});
				cache = Object.assign({}, { ...inputTypes });
			}
			await onSettingsResponse(res, device);
			loading = false;
		}
	};
</script>

<Text element="h2" styleType="h2" class="mb-s">
	{$format('input_type_desc', { default: 'Set input type' })}
</Text>

{#each inputOptions as option, index}
	<Radio
		size="m"
		selected={inputOptions[inputTypes[deviceChannel]]}
		value={option}
		on:click={() => setInputType(index)}
		id="radio-xtxsq1x"
	>
		{_input_options_i18n[index]}
	</Radio>
{/each}

<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}>
	{$format('button_save')}
</Button>
